module.exports = __webpack_public_path__ + "static/media/line.fragment.1dc2f741.glsl";